import { Icon, Checkbox } from 'semantic-ui-react';
import './LookbookEntryCard.css';

const LookbookEntryCard = ({
    entry,
    onClick,
    onDelete,
    isBulkMode = false,
    isSelected = false,
    isActive = false,
    isHorizontal = false
}) => {
    // Get the display image URLs - prioritize removed background version
    const getAllImagesUrls = () => {
        if (entry.allImages && Array.isArray(entry.allImages) && entry.allImages.length > 0) {
            return entry.allImages;
        }
        if (entry.useRemovedImage !== false && entry.removedBgImage?.url) {
            return [entry.removedBgImage.url];
        }
        const fallback = (Array.isArray(entry.resultImage) ? entry.resultImage[0]?.url : entry.resultImage?.url) || entry.imageUrl || entry.previewImage;
        return fallback ? [fallback] : [];
    };

    const imageUrls = getAllImagesUrls();

    return (
        <div
            className={`lookbook-entry-card ${isSelected ? 'selected' : ''} ${isActive ? 'active' : ''} ${isHorizontal ? 'horizontal' : ''}`}
            onClick={onClick}
        >
            {/* Active selection indicator - teal gradient fade + checkmark (matching clothing panel) */}
            {isActive && !isBulkMode && (
                <div className="selected-gradient-overlay">
                    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
                        <path d="M3 8L7 12L13 4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
            )}

            {/* Selection checkbox in bulk mode */}
            {/* Selection checkbox in bulk mode */}
            {isBulkMode && (
                <div className="bulk-checkbox-wrapper" onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        checked={isSelected}
                        onChange={onClick}
                    />
                </div>
            )}

            {/* Entry images */}
            <div className="entry-image-container">
                {imageUrls.length > 0 ? (
                    <div style={{ display: 'flex', overflowX: 'auto', width: '100%', height: '100%', scrollSnapType: 'x mandatory', scrollbarWidth: 'none', msOverflowStyle: 'none' }} className="lookbook-entry-scroll-container">
                        <style>{`
                            .lookbook-entry-scroll-container::-webkit-scrollbar { display: none; }
                        `}</style>
                        {imageUrls.map((url, idx) => (
                            <img
                                key={idx}
                                src={url}
                                alt={`Look ${idx + 1}`}
                                className="entry-image"
                                style={{ flex: '0 0 100%', width: '100%', height: '100%', objectFit: 'cover', scrollSnapAlign: 'start' }}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="entry-placeholder">
                        <Icon name="image outline" />
                    </div>
                )}
            </div>

            {/* Delete button - shows on hover (or always on mobile likely handled by CSS) */}
            {!isBulkMode && onDelete && (
                <div
                    className="card-delete-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete(entry);
                    }}
                    title="Delete Look"
                >
                    <Icon name="close" color="red" />
                </div>
            )}


        </div>
    );
};

export default LookbookEntryCard;
